import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
import { Filing } from '../interfaces/Filing';
const baseUrl = new APISettings().getApiURL();

class FilingWorkflowApi<FilingWorkFlow> extends BaseAPI {
  // constructor() {}

  public getAllFilingWorkflows: () => Promise<FilingWorkFlow> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filingWorkflow`)).data.output;
  };

  public getFilingWorkflowById: (formId: number) => Promise<FilingWorkFlow> = async (
    formId: number
  ) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/GetByFilingFormId/${formId}`)).data.output;
  };

  public createFilingWorkflow: (filing: Filing) => Promise<FilingWorkFlow> = async (
    filing: Filing
  ) => {
    return (await BaseAPI.axios.put(`${baseUrl}/filing`, filing)).data.output;
  };

  public updateFilingWorkflow: (filing: Filing) => Promise<FilingWorkFlow> = async (
    filing: Filing
  ) => {
    return (await BaseAPI.axios.put(`${baseUrl}/filing`, filing)).data.output;
  };
}

export const filingWorkflowAPI = new FilingWorkflowApi();
